import { render } from "./KWAssignProducts.vue?vue&type=template&id=1bd65e01&scoped=true"
import script from "./KWAssignProducts.vue?vue&type=script&lang=js"
export * from "./KWAssignProducts.vue?vue&type=script&lang=js"

import "./KWAssignProducts.vue?vue&type=style&index=0&id=1bd65e01&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bd65e01"]])

export default __exports__